import * as React from 'react'
import styled from 'styled-components'
import { sbEditable } from '@storyblok/storyblok-editable'
import { Button } from '../../components/UI/Button'
import { underscoreCase } from '../../lib/utils/underscoreCase'
import { ContactPersonBlok } from './types'
import CustomLink from '../../components/CustomLink'
import useEventTracking from '../../lib/hooks/tracking'

const Person = styled.div``

const Name = styled.h3`
  font-size: 0.9rem;
  line-height: 1.2;
`

const Position = styled.div`
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 0.5rem;
`

const Socials = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 1rem;
`

const Image = styled.img`
  width: 9rem;
  aspect-ratio: 1/1;
  border-radius: 1.5rem;
  object-fit: cover;
  object-position: center center;
  margin-bottom: 1rem;

  @media screen and (max-width: 480px) {
    width: 8rem;
  }
`

const Languages = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.colors.black[3]};

  span {
    font-size: 0.9rem;
    line-height: 1.5;

    &:not(:last-child) {
      display: flex;
      gap: 0.3rem;

      &:after {
        display: block;
        content: '·';
      }
    }
  }
`

export const ContactPersonsItem = ({ blok }: { blok: ContactPersonBlok }) => {
  const trackEvent = useEventTracking()
  return (
    <Person {...sbEditable(blok)}>
      <Image src={blok.image.filename} alt={blok.image.alt || blok.image.name || blok.name} />
      <Name>{blok.name}</Name>
      <Position>{blok.position}</Position>
      <Languages>
        {blok.spoken_languages.map((lang, i) => (
          <span key={i}>{lang}</span>
        ))}
      </Languages>
      {(blok.xingUrl || blok.linkedinUrl) && (
        <Socials>
          {blok.xingUrl && (
            <Button
              as={CustomLink}
              $size="small"
              $variant="tertiary"
              $ignoreTheme
              to={blok.xingUrl}
              iconLeft="logo-xing"
            ></Button>
          )}
          {blok.linkedinUrl && (
            <Button
              as={CustomLink}
              $size="small"
              $variant="tertiary"
              $ignoreTheme
              to={blok.linkedinUrl}
              iconLeft="logo-linkedin"
            ></Button>
          )}
        </Socials>
      )}
      {blok.email && (
        <Button
          as="a"
          $size="small"
          $variant="secondary"
          $ignoreTheme
          href={`mailto:${blok.email}`}
          onClick={() =>
            trackEvent('individual_contacted', {contact_selection: underscoreCase(blok.name)})
          }
          iconLeft="mail-plane"
        >
          Send e-mail
        </Button>
      )}
    </Person>
  )
}
